


import { Component, Vue } from 'vue-property-decorator';
import Jobseeker from '../../Jobseeker.vue';
import Myreferrals from '../../Myreferrals.vue';
import MyJoblisting from '../../../components/MyJobs/JobListing/MyJoblisting.vue';
import { UserJobStatusResponse } from '../../../models/jobs/userjobstatusresponse';
import { vxm } from './../../../store.vuex';
import { UserJobHistoryListRequest } from '../../../models/jobs/userjobhistorylistrequest';
import { UserJobListRequest } from '../../../models/jobs/userjoblistrequest';
import { UserJob } from '../../../models/jobs/userjob';
declare var window: any;

const LIST_ALL_MY_JOBS: string = '00';

@Component({
  name: 'MyJobStatus',
  components: {
    Jobseeker,
    Myreferrals,
    myjoblisting: MyJoblisting,
  },
})
export default class MyJobStatus extends Vue {
  private userJobStatusResponse: UserJobStatusResponse = new UserJobStatusResponse();
  private hasApplied: boolean = false;
  private wasHired: boolean = false;
  private hasOffer: boolean = false;
  public jobStatus: string = '01';
  myJobTabs: any[] = [];

  private statusTextMapping: any = {};

  get pageCount() {
    if (vxm.jobs.MyJobsPager.totalPages) {
      return vxm.jobs.MyJobsPager.totalPages;
    } else {
      return 0;
    }
  }

  get isLoggedIn() {
    console.log('url', this.thisURL);
    return vxm.users.isLoggedIn;
  }

  get thisURL() {
    return window.location.href.split('/')[
      window.location.href.split('/').length - 1
    ];
  }

  get myJobTabList() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const slideMenu = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (option) => option.sectionKey === 'MY_JOBS',
      );
      if (!slideMenu) {
        return [];
      }
      return slideMenu.subSections.map((option) => ({
        text: option.displayName,
        visibility: true,
        isActive: option.isActive,
        jobStatus: option.jobStatus,
        tabId: option.sectionKey,
      }));
    } else {
      return vxm.jobs.BrandingInfo.myJobTabs;
    }
  }

  get hideMyJobsStatus(){
    return vxm.configs.getGlobalConfigBooelanValue('HIDE_MY_JOB_STATUS');
  }
  
  getUserJobStatus(): UserJob[] {
    return vxm.jobs.UserJobStatusResponse.userJobs;
  }

  showOfferedTab() {
    const companyCode = vxm.jobs.BrandingInfo.companycode;
    return (
      companyCode &&
      !(companyCode.startsWith('EMRLD') || companyCode.startsWith('TC'))
    );
  }
  // INPROGRESS_APPLIED_JOBS = "01";
  // OFFERED_JOBS = "02";
  // HIRED_JOBS = "03";
  // SAVED_JOBS = "04";

  getJobs(jobStatus: string) {
    const userJobListRequest = new UserJobListRequest();
    userJobListRequest.resultSize = 10;
    userJobListRequest.resultPage = 1;
    userJobListRequest.jobStatus = jobStatus;
    // vxm.jobs.getJobStatus(userJobListRequest).then((res) => {
    //   // TBD
    // });
  }

  getMyJobsTab(myJobTab) {
    this.jobStatus = myJobTab.jobStatus;
    this.myJobTabs.forEach((tab) => {
      if (tab.tabId === myJobTab.tabId) {
        tab.isActive = true;
      } else {
        tab.isActive = false;
      }
    });
  }

  getApplied() {
    //this.getJobs("01");
    this.hasApplied = true;
    this.hasOffer = false;
    this.wasHired = false;
    this.jobStatus = '01';
  }

  getOffered() {
    // this.getJobs("02");
    this.hasApplied = false;
    this.hasOffer = true;
    this.wasHired = false;
    this.jobStatus = '02';
  }

  getHired() {
    //  this.getJobs("03");
    this.hasApplied = false;
    this.hasOffer = false;
    this.wasHired = true;
    this.jobStatus = '03';
  }

  getStatusText(tab) {
    return this.statusTextMapping[tab.jobStatus] || tab.text;
  }

  beforeMount() {
    this.myJobTabs = this.myJobTabList;
    if(this.hideMyJobsStatus) {
      this.jobStatus = LIST_ALL_MY_JOBS;
    } else if (this.$route.query.offered) {
      if (this.myJobTabList) {
        this.jobStatus = '02';
        this.myJobTabList.forEach((tab) => {
          if (tab.jobStatus === '02') {
            tab.isActive = true;
          } else {
            tab.isActive = false;
          }
        });
      }
    }
    this.statusTextMapping = {
      '01': this.$t('jobstatus-applied-text'),
      '02': this.$t('jobstatus-offered-text'),
      '03': this.$t('jobstatus-hired-text'),
    };
  }

  destroyed() {
    if (this.myJobTabList) {
      this.myJobTabList.forEach((tab) => {
        if (tab.jobStatus === '01') {
          tab.isActive = true;
        } else {
          tab.isActive = false;
        }
      });
    }
  }
}
